import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const RefreshIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M12 2.44 15.56 6 12 9.56 10.94 8.5l1.75-1.75h-1.061c-3.785.02-6.879 3.096-6.879 6.875a6.875 6.875 0 1 0 13.75 0v-.75H20v.75a8.375 8.375 0 1 1-16.75 0c0-4.615 3.772-8.35 8.371-8.375h1.068L10.94 3.5 12 2.44Z" />
  </IconWrapper>
)

export default RefreshIconMedium
